'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var svg_path = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M17.1853 13.3742L17.8168 9.39457H13.9263V6.8078C13.9263 5.71962 14.4695 4.6563 16.2063 4.6563H18V1.26738C16.9554 1.10219 15.9 1.01282 14.8421 1C11.64 1 9.54947 2.90899 9.54947 6.36009V9.39457H6V13.3742H9.54947V23H13.9263V13.3742H17.1853Z\" fill=\"#26201F\"/>\n</svg>";

exports["default"] = svg_path;
